import React, { useEffect } from "react";
import Hero from "./Hero";
import Dashboardimg from "../../components/Dashboardimg";
import Works from "./Works";
import Brands from "../../components/Brands";
import Case from "./Case";
import Integration from "./Integration";
import CTA from "../../components/CTA";
import Dashboard from "./Dashboard";
import Features from "./Features";
import { Helmet } from "react-helmet";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Home - Real Opinion</title>
        <meta
          name="description"
          content="RealOpinions.ai offers an easy-to-integrate surveywall for app publishers to boost user engagement, improve retention, and maximize monetization."
        />
        <meta
          name="keywords"
          content="Real Opinion, Survey, Survey Wall, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Real Opinion" />
        <meta
          title="Real Opinion"
          content="RealOpinions.ai offers an easy-to-integrate surveywall for app publishers to boost user engagement, improve retention, and maximize monetization."
        />
        xs
      </Helmet>
      <Hero />
      <Features />
      <Dashboard></Dashboard>
      <Dashboardimg></Dashboardimg>
      <Works></Works>
      <Brands></Brands>
      <Case></Case>
      <Integration></Integration>
      <CTA></CTA>
    </>
  );
};

export default Home;
